import { useState, useCallback } from 'react';
import { p922aApi, F921 } from '../../../services/p922aApi';

export function useLookupNames() {
  const [names, setNames] = useState<Record<string, string>>({});

  /** Batch-resolve all lookup names for master record */
  const resolveAllNames = useCallback(async (data: Partial<F921>) => {
    const entries: [string, string, string][] = [
      ['employee', 'employee', data.f921_02 || ''],
      ['department', 'department', data.f921_31 || ''],
      ['agent', 'employee', data.f921_10 || ''],
      ['leaveType', 'leaveType', data.f921_12 || ''],
      ['entryPerson', 'employee', data.f921_91 || ''],
      ['reviewer', 'employee', data.f921_22 || ''],
      ['approver', 'employee', data.f921_25 || ''],
      ['auditor', 'employee', data.f921_72 || ''],
      ['hrChecker', 'employee', data.f921_67 || ''],
    ];
    const results = await Promise.all(
      entries.map(([key, type, code]) =>
        p922aApi.lookupName(type, code).then(name => [key, name] as [string, string])
      )
    );
    setNames(prev => {
      const next = { ...prev };
      for (const [key, name] of results) next[key] = name;
      return next;
    });
  }, []);

  /** Resolve a single lookup name (for onBlur events) */
  const resolveSingleName = useCallback(async (nameKey: string, type: string, code: string) => {
    const name = await p922aApi.lookupName(type, code);
    setNames(prev => ({ ...prev, [nameKey]: name }));
  }, []);

  /** Clear all cached names */
  const clearNames = useCallback(() => {
    setNames({});
  }, []);

  return { names, setNames, resolveAllNames, resolveSingleName, clearNames };
}
